import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DragNDropModal from './drag_n_drop_modal';
import InsuranceChallenge1InitialText from '../../dragNDropText/insurance_challenge1_initial_text';
import InsuranceChallenge1HintsText from './text/insurance_challenge1_hints_text';
import InsuranceChallenge1Dataset from './Datasets/insurance_challenge1_dataset';
import InsuranceChallenge2InitialText from '../../dragNDropText/insurance_challenge2_initial_text';
import InsuranceChallenge2HintsText from './text/insurance_challenge2_hints_text';
import InsuranceChallenge2Dataset from './Datasets/insurance_challenge2_dataset';
import { createColumnArray } from '../../objects/DragNDrop/createColumnArray_function';
import { calcColumnScore } from '../../objects/DragNDrop/calcColumnScore_function';
import { dragNDropBefore } from '../../objects/DragNDrop/drag_n_drop_before_function';
import ExtraCreditConfigFile from './Datasets/extra_credit_config_file';

class InsuranceExtraCredit extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            callRender: false,
            openSw: false,
        }
        this.currentStatus = "DisplayChallenge1";
        this.dragNDrop = {};
        this.modalMessage = "";
        this.hintTable = [];
        this.hintNbr = 0;
        this.displayAlert = false;
        this.tableObject = [];
        this.tableNbrRows = 0;
        this.freezeFlag = false;
        this.challenge1Score = 0;
        this.challenge2Score = 0;
        this.avergeScore = 0;
        this.col1Text = "";
    }

    // getting error: "findDOMNode is deprecated and will be removed 
    // in the next major release. Instead, add a ref directly to the element you want to reference"

    openInsuranceChallenge1() {
        this.currentStatus = "OpenChallenge1";
        this.dragNDrop = dragNDropBefore ("Determine the Type of Insurance", 
                InsuranceChallenge1InitialText, "", "", "",
                InsuranceChallenge1Dataset, "InsuranceChallenge1", 99);
        this.hintTable = InsuranceChallenge1HintsText; 
        this.setState({openSw: true});
    }

    closeInsuranceChallenge1() {
        this.currentStatus = "DisplayChallenge1"
        this.setState({openSw: false});
    }

    saveInsuranceChallenge1() {
        var columnArray=createColumnArray(this.dragNDrop.cookieNamePfx, 2);
        if (columnArray.length === 1 ) {
            this.modalMessage = "Drag items from the Statements That are False " +
                "column to the Statements That are True column."
            this.setState({callRender: !this.state.callRender});
        }else{
            this.challenge1Score = calcColumnScore(columnArray);
            if (this.challenge1Score > 90) {
                this.modalMessage = "";
                sessionStorage.setItem("insuranceChallenge1Score", this.challenge1Score);
                this.currentStatus = "DisplayChallenge2";
                this.setState({openSw: false});
            } else {
                this.modalMessage= "Not quite right... Try again.";
                this.displayAlert = true;
                if (this.hintNbr < this.hintTable.length){
                    this.hintNbr += 1;
                }
                this.setState({callRender: !this.state.callRender});
            }    
            
        }
    }
     
    openInsuranceChallenge2() {
        this.currentStatus = "OpenChallenge2";
        this.modalMessage = "";
        this.dragNDrop = dragNDropBefore ("Is This Good Advice About Insurance?", 
                InsuranceChallenge2InitialText, "", "", "",
                InsuranceChallenge2Dataset, "InsuranceChallenge2", 99) 
        this.hintTable = InsuranceChallenge2HintsText; 
  
        this.setState({openSw: true});
    }

    closeInsuranceChallenge2() {
       this.currentStatus = "DisplayChallenge2";
       this.freezeFlag = false;
       this.setState({openSw: false});
    }

    saveInsuranceChallenge2() {
        var columnArray=createColumnArray(this.dragNDrop.cookieNamePfx, 3);
        this.challenge2Score = calcColumnScore(columnArray);
        if (this.challenge2Score > 85) {
            this.modalMessage = "";
            this.currentStatus = "DisplayChallenge2";
            this.finishInsuranceChallenge();
            this.setState({openSw: false});
        } else {
            this.modalMessage= "Not quite right... Try again.";
            this.displayAlert = true
            if (this.hintNbr < this.hintTable.length){
                this.hintNbr+=1;
            }
            this.setState({callRender: true});
        }   
    }

    getInsuranceChallenge1Score() {
        var challenge1Score = parseFloat(sessionStorage.getItem("insuranceChallenge1Score"));
        if (!isNaN(challenge1Score) && this.currentStatus === "DisplayChallenge1") {
           this.currentStatus = "DisplayChallenge2";
           this.challenge1Score = challenge1Score;
        }
    }
    
    closeAlert(){
        this.displayAlert = false;
        this.setState({callRender: true});
    }
    
    render() {
        this.getInsuranceChallenge1Score();
       
    return <>

        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="med" scrollable="true">
            <Modal.Header closeButton>
                <Modal.Title>Extra Credit - Insurance</Modal.Title> 
            </Modal.Header>
            <Modal.Body>
                {this.currentStatus === "DisplayChallenge1" ?
                     <span>
                        <div className="m-4">
                            <p>Insurance offers a nice safety net but it is also a fairly
                               complex topic.  This first exercise focuses on the 3 most common 
                               types of insurance (Automobile, Renters/Home and Health).  Can you 
                               determine which insurance covers various situations and which 
                               situations are not covered by insurance at all? </p>
                               <p></p> 
                               <p>Click on the "Challenge1" button to learn more and check
                               your understanding.</p>
                        </div>
                                                    
                        <div className="text-center">
                            <button className="btn btn-primary w-75 mt-4" 
                            onClick ={()=> this.openInsuranceChallenge1()}>
                                Insurance Challenge #1
                            </button>
                        </div>
                    </span>
                :
                    <div></div>
                }
                {this.currentStatus === "OpenChallenge1" ?
                    <DragNDropModal show={this.state.openSw} 
                        onClose={() => this.closeInsuranceChallenge1()} 
                        onSave={() => this.saveInsuranceChallenge1()}
                        closeAlert={() => this.closeAlert()}
                        inputDataset={this.dragNDrop.inputData}
                        modalSize={this.dragNDrop.modalSize}
                        modalTitle={this.dragNDrop.modalTitle}
                        introText={this.dragNDrop.introText}
                        cookieNamePfx={this.dragNDrop.cookieNamePfx}
                        buttonType={this.dragNDrop.buttonType}
                        message={this.modalMessage}
                        hintTable={this.hintTable}
                        hintNbr={this.hintNbr}
                        displayAlert={this.displayAlert}
                    />
                :
                    <div></div>
                }
           
                {this.currentStatus === "DisplayChallenge2" ?
                    <span>
                         <div className="m-4" >
                             <p>When it comes to insurance, the advice you follow can make a big difference
                                in your financial life. Since most adults have experience with insurance, 
                                there are a lot of people who are willing to give you advice.  The difficulty
                                is that not all of this advice is something you should really follow.  Do you
                                think you can distinguish between good advice and advice that is not good?  
                                </p>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-primary w-75 mt-4" 
                            onClick ={()=> this.openInsuranceChallenge2()}>
                                Insurance Challenge #2
                            </button>
                        </div>
                    </span>
                :
                    <div></div>
                }
                {this.currentStatus === "OpenChallenge2" ?
                    <DragNDropModal show={this.state.openSw} 
                        onClose={() => this.closeInsuranceChallenge2()} 
                        onSave={() => this.saveInsuranceChallenge2()}
                        onContinue={() => this.finishChallenge2()}
                        closeAlert={() => this.closeAlert()}
                        inputDataset={this.dragNDrop.inputData}
                        modalSize={this.dragNDrop.modalSize}
                        modalTitle={this.dragNDrop.modalTitle}
                        introText={this.dragNDrop.introText}
                        cookieNamePfx={this.dragNDrop.cookieNamePfx}
                        maxNbr={this.dragNDrop.maxNbrPerColumn}
                        buttonType={this.dragNDrop.buttonType}
                        message={this.modalMessage}
                        tableNbrRows={this.tableNbrRows}
                        tableCol1Text={this.state.col1Text}
                        tableObjectRow={this.tableObject}
                        freezeFlag={this.freezeFlag}
                        hintTable={this.hintTable}
                        hintNbr={this.hintNbr}
                        displayAlert={this.displayAlert}
                        />
                :
                    <div></div>
                }
            </Modal.Body>
            <Modal.Footer className="text-right">
                <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_img mr-5"
                    alt="train"/>
                <Button variant="secondary"   onClick={() => this.props.onClose()}>
                    Close
                </Button>
          </Modal.Footer>
          </Modal>             
            
        </>
    }

    finishInsuranceChallenge() {
        this.averageScore = (+this.challenge1Score +  +this.challenge2Score) / 2; 
        this.calculateInsurancePoints();
        sessionStorage.setItem("previousExtraCreditProcess", "Insurance");
        this.props.onCompleted(); 
    }

    calculateInsurancePoints(){
        var earnedAmt = 0;
        let processName = "Insurance";
        let earningsObj = ExtraCreditConfigFile.exercises.find(elem => elem.category === processName);
        earnedAmt = (+earningsObj.amt).toFixed(2);
        this.averageScore = this.averageScore.toFixed(2);
       
        const insuranceObj = {processName: processName, score: this.averageScore,
            assetType: earningsObj.type, amount: earnedAmt, level: earningsObj.level}
          
        sessionStorage.setItem("extraCreditCompleted", JSON.stringify(insuranceObj));
    }

}


export default InsuranceExtraCredit;